<script setup lang="ts">
import { tv } from "tailwind-variants"

const { variant = "filled", passive = false, size = "md" } = defineProps<{
  variant?: "filled" | "outline"
  passive?: boolean
  size?: "sm" | "md"
}>()

const cls = tv({
  variants: {
    variant: {
      filled: "bg-[--theme-medium] text-white",
      outline: "bg-transparent text-white shadow-[inset_0_0_0_2px_var(--theme-light)]",
    },
    passive: {
      true: "",
      false: "",
    },
    size: {
      sm: "px-1.5 pb-0.5 text-base leading-[20px]",
      md: "px-2 pb-[3px] text-sm/[18px] md:pb-0.5 md:text-xl/[24px]",
    },
  },
  compoundVariants: [
    {
      variant: "filled",
      passive: true,
      class: "bg-[--theme-translucent-light]",
    },
    {
      variant: "outline",
      passive: true,
      class: "!text-[--theme-medium] !shadow-[inset_0_0_0_2px_var(--theme-medium)]",
    },
  ],
})
</script>

<template>
  <span
    class="inline-flex size-fit gap-2 rounded-md font-national2 font-bold italic"
    :class="cls({ variant, passive, size })"
  >
    <slot />
  </span>
</template>
